import React from 'react';
import { StyledLogo } from './styledLogo';

import logo from '../../../assets/images/logo-main.svg';

const Logo = ({className}) => {
  return (
    <StyledLogo className={className}>
      <img src={logo} alt="exsoft-logo" className="logo-img"/>
    </StyledLogo>
  );
};

export default Logo;